/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Box, Container, Grid } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { footerStyle } from '../theme';
import { settings } from '../settings';

export const Footer = () => (
    <>
        <Box
            sx={{
                backgroundColor: footerStyle.background,
                color: footerStyle.text,
                fontFamily: 'Roboto',
                lineHeight: '24px',
                padding: '40px 0',
                a: {
                    textDecoration: 'none',
                    color: '#7286a0',
                },
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={5}>
                    <Grid item xs={12} sm={4} md={4} sx={{}}>
                        <h3
                            css={css`
                                padding-bottom: 0.5em;
                            `}
                        >
                            About
                        </h3>
                        <p>
                            LSoft Technologies Inc. is a privately owned North American software company. Our goal is to
                            create world’s leading data recovery, security and backup solutions by providing rock solid
                            performance, innovation, and unparalleled customer service.
                        </p>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4} sx={{}}>
                        <h3
                            css={css`
                                padding-bottom: 0.5em;
                            `}
                        >
                            Contact Us
                        </h3>
                        <h4>{settings.email}</h4>
                        <p>
                            {settings.phone1}
                            <br />
                            {settings.phone2}
                            <br />
                            {settings.hours}
                        </p>
                        <p>Fax: {settings.fax}</p>
                        <div
                            css={css`
                                a {
                                    padding-right: 20px;
                                }
                            `}
                        >
                            <a href={settings.socials.facebook}>
                                <FacebookIcon />
                            </a>
                            <a href={settings.socials.twitter}>
                                <TwitterIcon />
                            </a>
                            <a href={settings.socials.youtube}>
                                <YouTubeIcon />
                            </a>
                        </div>
                    </Grid>
                    <Grid item>
                        <h3
                            css={css`
                                padding-bottom: 0.5em;
                            `}
                        >
                            Address
                        </h3>
                        <h4>LSoft Technologies Inc.</h4>
                        <p>
                            {settings.address.map((line, idx) => (
                                <span key={idx}>
                                    {line}
                                    <br />
                                </span>
                            ))}
                        </p>
                    </Grid>
                </Grid>
            </Container>
        </Box>
        <Box
            sx={{
                backgroundColor: footerStyle.bottomBackground,
                color: footerStyle.text,
            }}
        >
            <Container maxWidth="lg">
                <p
                    css={css`
                        margin: 0;
                        padding: 16px;
                    `}
                >
                    &copy; {settings.year} LSoft Technologies Inc. All Rights Reserved.
                </p>
            </Container>
        </Box>
    </>
);
